import { render, staticRenderFns } from "./SignupScreen.vue?vue&type=template&id=3b9aaf70&"
import script from "./SignupScreen.vue?vue&type=script&lang=ts&"
export * from "./SignupScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports